<svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="none" role="presentation">
    <path
        stroke="#020621"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.2"
        d="M3.08612 15.7233c-1.15208 0-2.087097-.9423-2.087097-2.1034 0-1.161.935017-2.1033 2.087097-2.1033M15.6089 23.4223h2.0871c2.0182 0 3.6524-1.1211 3.6524-3.1551V19.001"
    />
    <path
        stroke="#020621"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.2"
        d="M15.6087 23.4222c0 .8708-.7013 1.5775-1.5653 1.5775-.8641 0-1.5654-.7067-1.5654-1.5775 0-.8708.7013-1.5775 1.5654-1.5775.864 0 1.5653.7067 1.5653 1.5775ZM7.26014 18.878h-2.0871c-1.15208 0-2.0871-.9423-2.0871-2.1033v-6.31c0-1.16107.93502-2.10337 2.0871-2.10337h2.0871V18.878Z"
        clip-rule="evenodd"
    />
    <path
        stroke="#020621"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.2"
        d="M22.9136 15.7233c1.1521 0 2.0871-.9423 2.0871-2.1034 0-1.161-.935-2.1033-2.0871-2.1033"
    />
    <path
        stroke="#020621"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.2"
        d="M18.7393 18.878h2.0871c1.152 0 2.0871-.9423 2.0871-2.1033v-6.31c0-1.16107-.9351-2.10337-2.0871-2.10337h-2.0871V18.878Z"
        clip-rule="evenodd"
    />
    <path
        stroke="#020621"
        stroke-linejoin="round"
        stroke-width="1.2"
        d="M5.69482 8.3617C5.69482 4.29594 8.96531 1 12.9997 1c4.0333 0 7.3048 3.29594 7.3048 7.3617"
    />
</svg>
